export function validatePassword(entry) {
  return Boolean(entry) && entry.length >= 8
}

export function validateEmail(email) {
  return new RegExp('.+@.+').test(email)
}



// WEBPACK FOOTER //
// ./src/utils/validation.js